import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import { wxlogin,wxgetinfo,wxlogout,user_xiaoxi_num } from "@/api/user"
const state = {
  token: getToken(),
  nickname: '',
  headimgurl: '',
  notice:{
  	num:0,
  	type01:0,
  	type02:0,
  	type03:0,
  	type04:0
  }
}
const mutations = {
	SET_TOKEN: (state, token) => {
	  state.token = token
	},
	SET_HEADIMGURL: (state, headimgurl) => {
	  state.headimgurl = headimgurl
	},
	SET_NICKNAME: (state, nickname) => {
	  state.nickname = nickname
	},
	SET_NOTICE: (state, notice) => {
	  state.notice = notice
	},
}
const actions = {
	//登录接口
	login({commit},userInfo){
		const { token } = userInfo
		return new Promise((resolve,reject)=>{
			commit('SET_TOKEN', token)
			setToken(token)
			resolve(token)	
		})
	},
	//消息
	noticeinfo({commit,state}){
	   return new Promise((resolve,reject)=>{
		   user_xiaoxi_num({}).then(res=>{
			   console.log("消息列表",res.data);
			   commit("SET_NOTICE",res.data);
			   resolve(res.data)
		   })
	   })	
	},
	//获取个人信息
	getInfo({ commit, state }) {
		return new Promise((resolve, reject) => {
			wxgetinfo({}).then(response=>{
				console.log("个人信息",response.data);
				const { nickname,headimgurl } = response.data
				commit('SET_NICKNAME', nickname)
				commit('SET_HEADIMGURL', headimgurl)
				resolve(response.data)
			}).catch(error => {
				reject(error)
			  })
		})
	},
	// remove token
	resetToken({ commit }) {
	  return new Promise(resolve => {
	    commit('SET_TOKEN', '')
	    removeToken()
	    resolve()
	  })
	},
	//退出登录
	// user logout
	logout({ commit, state, dispatch }) {
	  return new Promise((resolve, reject) => {
	    wxlogout({}).then(() => {
	      commit('SET_TOKEN', '')
	      removeToken()
	      resolve()
	    }).catch(error => {
	      reject(error)
	    })
	  })
	},
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js